import { useEffect } from 'react';
import { useCiamStore } from '../../context';
const RedirectToSignIn = _ref => {
  let {
    options
  } = _ref;
  const redirectToSignIn = useCiamStore(state => state.redirectToSignIn);
  useEffect(() => {
    redirectToSignIn(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
export default RedirectToSignIn;